import { identify, initialize } from '../lib/handlers';
import { refetchProfile } from '../lib/handlers/profile';
import { useIdentityStore } from '../lib/store';

export const useIdentity = () => {
	const {
		companyError,
		userError,
		featuresError,
		globalError,
		isInitialized,
		isLoadingCompany,
		isLoadingFeatures,
		isLoadingUser,
		isCompanyFetched,
		isUserFetched,
		areFeaturesFetched,
	} = useIdentityStore();

	const isLoading = [isLoadingCompany, isLoadingFeatures, isLoadingUser].some(Boolean);

	const isUserIdentified = [isCompanyFetched, isUserFetched, areFeaturesFetched].every(Boolean);

	const error = globalError || userError || companyError || featuresError;

	return {
		error,
		isInitialized,
		isUserIdentified,
		isLoading,
		identify,
		initialize,
		refetchProfile,
	};
};
